import { isBlob } from './services';
import { createSlice, createSelector } from '@reduxjs/toolkit';

const audioSlice = createSlice({
  name: 'audio',
  initialState: {
    currentAudioUrl: null,
    previousAudioUrl: null,
    playlist: {},
    readyToPlay: false,
    readyToPlayBlob: false,
    audioSampleKey: '',
  },
  reducers: {
    setCurrentAudioUrl(state, action) {
      state.previousAudioUrl = state.currentAudioUrl;
      state.currentAudioUrl = action.payload;
    },
    setToPlaylist(state, action) {
      const currentAudioUrl = action.payload.fileUrl;
      const localUrl = action.payload.url;

      state.playlist = { ...state.playlist, [currentAudioUrl]: localUrl };
    },
    resetAudioUrls(state, _) {
      state.previousAudioUrl = null;
      state.currentAudioUrl = null;
    },
    setReadyToPlay(state, action) {
      state.readyToPlayBlob = false;
      state.readyToPlay = action.payload;
    },
    setBlobReadyToPlay(state, action) {
      state.readyToPlay = false;
      state.readyToPlayBlob = action.payload;
    },
    setAudioSampleKey(state, action) {
      state.audioSampleKey = action.payload;
    },
  },
  selectors: {
    getPlaylist: (state) => state.playlist,
    getReadyToPlay: (state) => state.readyToPlay,
    getReadyToPlayBlob: (state) => state.readyToPlayBlob,
    getCurrentAudioUrl: (state) => state.currentAudioUrl,
    getPreviousAudioUrl: (state) => state.previousAudioUrl,
    getAudioSampleKey: (state) => state.audioSampleKey,
  },
});

export const reducer = audioSlice.reducer;
export const {
  setCurrentAudioUrl,
  setToPlaylist,
  resetAudioUrls,
  setReadyToPlay,
  setBlobReadyToPlay,
  setAudioSampleKey,
} = audioSlice.actions;
export const {
  getPlaylist,
  getReadyToPlay,
  getReadyToPlayBlob,
  getCurrentAudioUrl,
  getPreviousAudioUrl,
  getAudioSampleKey,
} = audioSlice.selectors;

export const makeGetPlayingByUrl = (url) =>
  createSelector(getCurrentAudioUrl, (stateFileUrl) => {
    if (!stateFileUrl) {
      return false;
    }
    if (isBlob(url)) {
      return true;
    }
    return stateFileUrl === url;
  });
